import React from 'react';

interface TextIconProps {
  wrapperClassNames?: string;
}

const TextIcon = ({ wrapperClassNames }: TextIconProps) => (
  <svg
    className={wrapperClassNames}
    width="12"
    height="10"
    viewBox="0 0 12 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.695164 0.652344C0.334978 0.652344 0.0387276 0.926083 0.00310329 1.27687C0.000728336 1.30026 -0.000488281 1.32398 -0.000488281 1.348V2.04365C-0.000488281 2.42785 0.310966 2.7393 0.695164 2.7393C1.07936 2.7393 1.39082 2.42785 1.39082 2.04365H3.12995V8.04976C2.92202 8.17004 2.78212 8.39485 2.78212 8.65234C2.78212 9.03654 3.09357 9.348 3.47777 9.348H4.17342C4.55762 9.348 4.86908 9.03654 4.86908 8.65234C4.86908 8.39485 4.72918 8.17004 4.52125 8.04976V2.04365L6.43429 2.04365C6.43429 2.42785 6.74575 2.7393 7.12995 2.7393C7.51414 2.7393 7.8256 2.42785 7.8256 2.04365V1.348C7.8256 0.963798 7.51414 0.652344 7.12995 0.652344H0.695164Z"
      fill="#655DFD"
    />
    <path
      d="M6.60914 3.78272C6.27297 3.78272 5.99249 4.02118 5.92762 4.33817C5.91836 4.38346 5.91349 4.43035 5.91349 4.47837V5.17402C5.91349 5.55822 6.22494 5.86968 6.60914 5.86968C6.99334 5.86968 7.30479 5.55822 7.30479 5.17402H8.17436V8.0497C7.96643 8.16998 7.82653 8.3948 7.82653 8.65229C7.82653 9.03648 8.13799 9.34794 8.52218 9.34794H9.21784C9.60204 9.34794 9.91349 9.03648 9.91349 8.65229C9.91349 8.3948 9.77359 8.16998 9.56566 8.0497V5.17402H10.6091C10.6091 5.55822 10.9206 5.86968 11.3048 5.86968C11.689 5.86968 12.0004 5.55822 12.0004 5.17402V4.47837C12.0004 4.09417 11.689 3.78272 11.3048 3.78272H6.60914Z"
      fill="#655DFD"
    />
  </svg>
);

export default TextIcon;
